export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_16-af0fe54a71d0c41b628bb96b6f47fa2a.jpg";